/**
 * change state of saved question filter
 * @param status
 */
export const changeSavedQuestionFilterVal = (status) => dispatch => {
    dispatch( {
        type: 'QUESTION_FILTER_CHANGE',
        payload: status
    });
};